module.exports = __webpack_public_path__ + "static/media/used4.75593df7.JPG";